import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';
import logoImage from '../assets/images/bca-mark.png';

const links = [
  { to: '/', label: 'Home', end: true },
  { to: '/about-us', label: 'About Us' },
  { to: '/contact-us', label: 'Contact Us' },
];

function NavLinks({ onLinkClick, className }) {
  return links.map((link) => (
    <NavLink
      key={link.to}
      to={link.to}
      end={link.end}
      className={({ isActive }) =>
        `${className}${isActive ? ' is-active' : ''}`
      }
      onClick={onLinkClick}
    >
      {link.label}
    </NavLink>
  ));
}

function Navbar() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  // The home hero is already the full logo, so only show it on inner pages
  const isHome = useLocation().pathname === '/';

  useEffect(() => {
    if (!open) return undefined;

    document.body.style.overflow = 'hidden';
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  return (
    <header className="navbar">
      <div className="navbar-inner">
        {!isHome && (
          <Link to="/" className="navbar-logo" aria-label="BCA Ventures home">
            <img src={logoImage} alt="BCA Ventures" />
          </Link>
        )}

        <button
          type="button"
          className={`navbar-toggle${open ? ' is-open' : ''}`}
          aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <button
        type="button"
        className={`navbar-overlay${open ? ' is-open' : ''}`}
        aria-hidden={!open}
        tabIndex={-1}
        onClick={close}
      />

      <aside
        className={`navbar-drawer${open ? ' is-open' : ''}`}
        data-lenis-prevent
        aria-hidden={!open}
      >
        <div className="navbar-drawer-top">
          <span className="navbar-drawer-title">Menu</span>
          <button
            type="button"
            className="navbar-drawer-close"
            aria-label="Close navigation menu"
            onClick={close}
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <line x1="5" y1="5" x2="19" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <line x1="19" y1="5" x2="5" y2="19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <nav className="navbar-drawer-links">
          <NavLinks onLinkClick={close} className="navbar-drawer-link" />
        </nav>
      </aside>
    </header>
  );
}

export default Navbar;
